import React, { useEffect, useMemo, useState } from "react";
import s from "./Textarea.module.css";
import { clsx } from "../../utils/clsx";

export default function Textarea({
  className,
  error,
  hint,
  variant = "default",
  shape = "default",
  color = "default",
  slotProps,
  size,
  align,
  maxLength,
  onChange,
  value,
  defaultValue,
  ...rest
}) {
  const colorClass = color !== "default" ? s[`color${color[0].toUpperCase()}${color.slice(1)}`] : undefined;
  const showCounter = useMemo(() => maxLength !== undefined && maxLength !== null && maxLength !== "", [maxLength]);

  const getLength = (input) => {
    if (input === undefined || input === null) return 0;
    return String(input).length;
  };

  const [charCount, setCharCount] = useState(() => getLength(value !== undefined ? value : defaultValue));

  useEffect(() => {
    if (!showCounter) return;
    if (value !== undefined) {
      setCharCount(getLength(value));
    } else if (defaultValue !== undefined) {
      setCharCount(getLength(defaultValue));
    }
  }, [value, defaultValue, showCounter]);

  const handleChange = (event) => {
    if (showCounter) {
      setCharCount(event.target.value.length);
    }
    if (typeof onChange === "function") {
      onChange(event);
    }
  };

  return (
    <div className={s.wrap}>
      <textarea
        {...rest}
        maxLength={maxLength}
        value={value}
        defaultValue={value === undefined ? defaultValue : undefined}
        className={clsx(
          s.area,
          variant === "filled" && s.variantFilled,
          variant === "borderless" && s.variantBorderless,
          shape === "round" && s.areaRound,
          colorClass,
          className
        )}
        aria-invalid={!!error || undefined}
        onChange={handleChange}
      />
      {(error || hint || showCounter) && (
        <div className={s.footerRow}>
          <div className={s.footerMessage}>
            {error ? (
              <span className={s.error} role="alert">{error}</span>
            ) : hint ? (
              <span className={s.hint}>{hint}</span>
            ) : null}
          </div>
          {showCounter ? (
            <div className={clsx(s.counter, error && s.counterError)}>
              {charCount}/{maxLength}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
